import DealContext from './DealContext';
import useGlobalContext, { GlobalContext } from './GlobalContext';
import InvoiceContext from './InvoiceContext';
import ProjectContext from './ProjectContext';

export default useGlobalContext;
export { DealContext, InvoiceContext, ProjectContext, GlobalContext };
